import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import { useLinkClickHandler } from 'react-router-dom';

interface ButtonLinkProps extends ButtonProps {
  to: string;
  external?: boolean; // optional override, otherwise auto-detect
}

const ButtonLink: React.FC<ButtonLinkProps> = ({ to, children, onClick, external, ...props }) => {
  // Auto-detect external if it starts with http:// or https://
  const isExternal = external ?? /^https?:\/\//i.test(to);

  const navigate = useLinkClickHandler<HTMLButtonElement>(to);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isExternal) {
      navigate(e);
      // Note: scroll to top is now handled by Layout component
    }
    onClick?.(e);
  };

  if (isExternal) {
    return (
      <Button
        as="a"
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </Button>
    );
  }

  return (
    <Button {...props} onClick={handleClick}>
      {children}
    </Button>
  );
};

export default ButtonLink;
